import cn from 'classnames';
import styles from './button.module.css';
import SVG from '@svg/chevron-right.svg';

const Button = ({ children, onClick = () => {}, darkTheme = false, href, ...rest }) => {
  return (
    <div
      className="snf-lx-components-servizi-soluzioni-button-button"
      style={{ display: 'contents' }}
    >
      <>
        <button
          className={cn(`${styles.button} mobile snf-font-14 snf-font-md-20 container-fluid`, {
            dark: darkTheme
          })}
          type="button"
          onClick={onClick}
          href={href}
          {...rest}
        >
          <div className="row no-gutters justify-content-md-between align-items-center">
            <div className="col-auto" style={{ maxWidth: '80%' }}>
              {children}
            </div>

            <div id="arrow-column" className="col-auto">
              <SVG className={styles.arrow} />
            </div>
          </div>
        </button>
      </>
    </div>
  );
};

Button.displayName = 'Button';
export { Button };
